let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5KlPN")).then(() => parcelRequire('5pnqQ'));